import { forwardRef, ReactNode, CSSProperties, MouseEvent } from 'react'
import clsx from 'clsx'
import styles from './listTile.module.css'
import { createRipple } from '../utils'

type Props = {
  children: ReactNode
  className?: string
  style?: CSSProperties
} & React.HTMLAttributes<HTMLDivElement>

export const ListTile = forwardRef<HTMLDivElement, Props>(
  ({ children, className, style, onMouseDown, ...rest }, ref) => {
    const handleMouseDown = (e: MouseEvent<HTMLDivElement>) => {
      createRipple(e, styles.ripple)
      onMouseDown?.(e)
    }

    return (
      <div
        ref={ref}
        className={clsx(styles.listTile, className)}
        style={style}
        onMouseDown={handleMouseDown}
        {...rest}
      >
        {children}
      </div>
    )
  },
)

ListTile.displayName = 'ListTile'
